// extracted by mini-css-extract-plugin
export default {"pounceFooter":"PounceFooterNav_pounceFooter__YjXRt","pounceFooterItem":"PounceFooterNav_pounceFooterItem__1k5Wj","pounceFooterActive":"PounceFooterNav_pounceFooterActive__GjaEq"};